import { takeLatest } from 'redux-saga'
import { put, select, take, fork, cancel } from 'redux-saga/effects'

import actionTypes from 'redux/actions/actionTypes'
import flocabularyActions from 'redux/actions/flocabularyActions'
import {flocabularySync, customSlideSync} from 'sync'
import {flocabularySelectors} from 'redux/selectors'
import externalApiTypes from 'helpers/enums/externalApiTypes'

import callAny from './helpers/call_any'
import formatError from './helpers/error_formatter'

function *flocabularyCreateInitialize(action) {
	try {
		const flocabularyData = yield callAny(customSlideSync.getCustomSlide,
			action.flocabularyUID, null, externalApiTypes.FLOCABULARY_UID)
		const cancelUrl = flocabularyData.payload.custom_slide.cancelUrl ? flocabularyData.payload.custom_slide.cancelUrl : ''
		let video = null
		const videoId = flocabularyData.payload['custom_slide']['data_all'] ? flocabularyData.payload['custom_slide']['data_all'].videoId : 0
		if (videoId) {
			const videoResponse = yield callAny(flocabularySync.getVideo,
				videoId)
			video = videoResponse.payload.video
		}
		yield put(flocabularyActions.initializeFlocabularySuccess(
			video, cancelUrl
		))
	} catch (error) {
		const serverError = formatError(error)
		yield put(flocabularyActions.initializeFlocabularyError(serverError))
	}
}

function *flocabularyGetPreviewData({videoId}) {
	try {
		const video = yield callAny(flocabularySync.getVideo, videoId)
		yield put(flocabularyActions.previewDataFetched(video.payload.video))
	} catch (error) {
		const serverError = formatError(error)
		yield put(flocabularyActions.previewDataFetchedError(serverError))
	}
}

function *getFlocabularyCategories() {
	try {
		const response = yield callAny(flocabularySync.getFlocabularyCategories)
		yield put(flocabularyActions.categoriesFetched(response.payload))
	} catch (error) {
		const serverError = formatError(error)
		yield put(flocabularyActions.categoriesFetchedError(serverError))
	}
}

function *flocabularySave(action) {
	try {
		const saveSelector = yield select(
			flocabularySelectors.saveSelector(action.videoId)
		)
		const response = yield callAny(customSlideSync.putCustomSlide,
			saveSelector.entityUID, saveSelector.saveData,
			externalApiTypes.FLOCABULARY_UID)
		yield put(flocabularyActions.saveFlocabularySuccess(
			response.payload.custom_slide.returnUrl, saveSelector.saveData.title
		))
	} catch (error) {
		const serverError = formatError(error)
		yield put(flocabularyActions.saveFlocabularyError(serverError))
	}
}

function *flocabularyGetVideoData(action) {
	try {
		const session = yield callAny(customSlideSync.getCustomSlide,
			action.flocabularyUID, action.jwt, externalApiTypes.FLOCABULARY_UID)
		const video = yield callAny(flocabularySync.getVideo, session.payload['custom_slide']['data_all'].videoId, action.jwt)
		yield put(flocabularyActions.videoDataFetched(video.payload.video))
	} catch (error) {
		const serverError = formatError(error)
		yield put(flocabularyActions.videoDataFetchedError(serverError))
	}
}

function *flocabularySearchVideos() {
	while (true) {
		try {
			let response
			const searchSelector = yield select(
				flocabularySelectors.searchSelector
			)
			if (searchSelector.searchQuery !== '') {
				if (searchSelector.hasMore
					|| !searchSelector.currentVideosIds.length) {
					response = yield callAny(flocabularySync.getResultsBySearch,
						searchSelector.searchQuery, searchSelector.page)
				}
			} else {
				response = yield callAny(flocabularySync.getResultsByTopic,
					searchSelector.categorySelected, searchSelector.isSubject, searchSelector.page)
			}
			if (response) {
				yield put(flocabularyActions.getResultsSuccess(
					response.payload
				))
			}
		} catch (error) {
			const serverError = formatError(error)
			yield put(flocabularyActions.getResultsError(serverError))
		}
		yield take(actionTypes.FLOCABULARY_VIDEOS_NEXT_PAGE_REQUESTED)
	}
}

function *getVideosPage() {
	let current_request
	while (true) {
		const action = yield take([actionTypes.FLOCABULARY_CATEGORIES_FETCHED,
			actionTypes.FLOCABULARY_CATEGORY_FLOCABULARY_SELECTED,
			actionTypes.FLOCABULARY_EDIT_FLOCABULARY,
			actionTypes.FLOCABULARY_APPLY_SEARCH_SELECTED])
		if (current_request) {
			yield cancel(current_request)
		}
		current_request = yield fork(flocabularySearchVideos, action)
	}
}

export default [
	fork(getVideosPage),
	takeLatest([actionTypes.FLOCABULARY_INITIALIZE_CREATION_TOOL,
		actionTypes.FLOCABULARY_INITIALIZE_CREATION_TOOL_STANDALONE],
	flocabularyCreateInitialize),
	takeLatest([actionTypes.FLOCABULARY_INITIALIZE_SESSION,
		actionTypes.FLOCABULARY_SCREENSHOT_INITIALIZE_ROUTE],
	flocabularyGetVideoData),
	takeLatest(actionTypes.FLOCABULARY_VIDEO_SELECTED, flocabularySave),
	takeLatest(actionTypes.FLOCABULARY_INITIALIZE_SUCCESS,
		getFlocabularyCategories),
	takeLatest(actionTypes.FLOCABULARY_VIDEO_PREVIEW_SELECTED,
		flocabularyGetPreviewData),
]

export {
	flocabularyCreateInitialize,
	flocabularyGetVideoData,
	flocabularyGetPreviewData,
}
